export type PartnerOpportunitySubmissionInput = {
  prospect_name: string;
  parent_entity?: string;
  website?: string;
  category?: string;
  notes?: string;
  expected_close_date?: string;
};

export function normalizePartnerOpportunitySubmission(input: PartnerOpportunitySubmissionInput) {
  return {
    prospect_name: input.prospect_name.trim().slice(0, 240),
    parent_entity: input.parent_entity?.trim().slice(0, 160) || undefined,
    website: input.website?.trim().slice(0, 500) || undefined,
    category: input.category?.trim().slice(0, 120) || undefined,
    notes: input.notes?.trim().slice(0, 2000) || undefined,
    expected_close_date: input.expected_close_date?.trim() || undefined,
  };
}

export const DEFAULT_OWNERSHIP_WINDOW_MONTHS = 6;

export function deriveOwnershipExpiresAt(activityDate?: string, windowMonths = DEFAULT_OWNERSHIP_WINDOW_MONTHS): string | undefined {
  if (!activityDate || !Number.isFinite(windowMonths) || windowMonths <= 0) return undefined;
  const date = new Date(`${activityDate.slice(0, 10)}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return undefined;
  date.setUTCMonth(date.getUTCMonth() + Math.floor(windowMonths));
  return date.toISOString().slice(0, 10);
}

export function deriveOwnershipWindowStatus(expiresAt?: string, now = new Date()): "active" | "expires_soon" | "expired" | "not_set" {
  if (!expiresAt) return "not_set";
  const expiry = new Date(`${expiresAt.slice(0, 10)}T23:59:59Z`);
  if (Number.isNaN(expiry.getTime())) return "not_set";
  if (expiry.getTime() < now.getTime()) return "expired";
  if (expiry.getTime() <= now.getTime() + 30 * 24 * 60 * 60 * 1000) return "expires_soon";
  return "active";
}

export function canRequestClaim(claimStatus: "yours" | "claimed" | "open" | "in_review" | "expired" | "won", stage: string): boolean {
  return !["yours", "claimed", "won"].includes(claimStatus) && !["won", "closed_won", "lost", "closed_lost", "duplicate", "rejected", "rejected_duplicate"].includes(stage);
}
